import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { LADAAT_SERVER } from 'src/environments/environment';

@Injectable()
export class AccessTokenInterceptor implements HttpInterceptor {

  constructor() { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (request.url.includes(LADAAT_SERVER)) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${localStorage.getItem('LadaaToken')}`
        }
      });
    }
    return next.handle(request);
  }

}
